import { render } from "./frequencyLimit.vue?vue&type=template&id=d7c7a4ea&scoped=true"
import script from "./frequencyLimit.vue?vue&type=script&lang=js"
export * from "./frequencyLimit.vue?vue&type=script&lang=js"

import "./frequencyLimit.vue?vue&type=style&index=0&id=d7c7a4ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d7c7a4ea"

export default script